import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const TrustBarItemIconContainer = styled.div`
    text-align: ${props => props.theme.style.textAlign.center};
    line-height: 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        text-align: ${props => props.theme.style.textAlign.left};
    }
`

/* To set aspect ratio of image */
export const TrustBarItemIcon = styled.img`
    width: 2.375rem;
    height: 2.25rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 3.4375rem;
        height: 3.25rem;
    }
`

export const TrustBarItemContent = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.9375rem;
    margin-top: 0.625rem;
    line-height: normal;
    text-align: ${props => props.theme.style.textAlign.center};
    font-weight: bold;
    color: ${props => props.theme.colors.white};
    max-width: 8.75rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-family: ${props => props.theme.typography.font.family.yummo};
        margin-top: 0.9375rem;
        font-size: ${props => props.theme.typography.font.size.xLarge};
        max-width: 14.375rem;
        text-align: ${props => props.theme.style.textAlign.left};
    }
`
